var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M7.116 14.129a6.737 6.737 0 003.928-1.266l4.166 4.166c.194.194.449.29.721.29.571 0 .976-.44.976-1.002a.968.968 0 00-.282-.703l-4.14-4.148a6.731 6.731 0 001.39-4.096c0-3.718-3.041-6.759-6.76-6.759C3.399.611.358 3.652.358 7.371c0 3.717 3.04 6.758 6.759 6.758zm0-1.46c-2.9 0-5.3-2.399-5.3-5.299 0-2.9 2.4-5.3 5.3-5.3s5.3 2.4 5.3 5.3-2.4 5.3-5.3 5.3z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "static/media/searchIcon.babeefe0.svg";
export { SvgSearchIcon as ReactComponent };